<template>
  <div class="z-nav-menu">
    <div class="menu-title">代扣代缴</div>
    <ul class="menu-list">
      <li class="menu-item" v-for="item in menuList"
          @click="handleMenuRouter(item)">
        <span :class="['iconfont' ,item.iconclass, 'myIcon']"></span>
        <span class="menu-name" :class="{'menu-active': activeMenu === item.id}">{{item.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import UserPersistence from "../persistence/UserPersistence";

export default {
  name: "z-nav-menu",
  data(){
    return {
      menuList: [
        {name: '人员信息采集', id: 1, routerName: 'personal-info', iconclass:"icon-renyuan"},
        {name: '专项附加扣除信息采集', id: 2, routerName: 'special-additional-deductions',iconclass:'icon-guyou'},
        {name: '个人养老金缴费信息采集', id: 11, routerName: 'personal-pension-payment-info', iconclass:"icon-gerenxinxi_o"},
        {name: '综合所得申报', id: 3,routerName: 'consolidated-income-tax-statement',iconclass:'icon-xiangmushenbaoguanli'},
        {name: '分类所得申报', id: 4 ,routerName: 'declaration-classified-income', iconclass:'icon-xiangmushenbaoguanli'},
        {name: '非居民所得申报', id: 5,iconclass:'icon-xiangmushenbaoguanli'},
        {name: '限售股所得申报', id: 6,iconclass:'icon-xiangmushenbaoguanli'},
        {name: '税款缴纳', id: 7, iconclass:"icon-nashuirenshibiehao1"},//routerName: 'tax-payment'
        {name: '退付手续费核对', id: 8,iconclass:"icon-heduixinxibaogao"},
        {name: '优惠备案', id: 9,iconclass:"icon-xiangmushouxubeian"},
        {name: '查询统计', id: 10,iconclass:"icon-chaxuntongji"}
      ]
    }
  },
  methods: {
    ...mapMutations('app',['setActiveMenu']),
    handleMenuRouter(item){
      const year = UserPersistence.getDate().split('-')[0] * 1
      if (item.id === 11 && year < 2022) {
        this.$msgbox({
          type: "warning",
          message: '根据政策要求只能办理2022年及之后的相关业务'
        })
        return
      }
      this.setActiveMenu(item.id)

      this.$router.push({
        name: item.routerName,
      })
    }
  },
  computed: {
   ...mapState('app' ,{
      activeMenu :state => state.activeMenu
   }

   )
  },
  mounted() {

  },
  watch: {

  },

}
</script>

<style lang="scss" scoped>
@import '../styles/baseConfig.scss';
  .z-nav-menu{
    .menu-title{
      position: relative;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      background-color: #ACBAC3;
      &:after{
        position: absolute;
        bottom: -4px;
        left: 50%;
        margin-left: -4px;
        content: ' ';
        width: 8px;
        height: 8px;
        transform: rotate(45deg);
        background-color: #ACBAC3;
      }
    }
    .menu-list{
      .menu-item{
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        &:hover{
          cursor: default;
        }
        &:first-child{
          margin-top: 5px;
        }
        .menu-icon{
          padding: 10px;
        }
        .menu-name{
          &.menu-active{
            color: $all-color;
          }
          &:hover{
            color: $all-color;
          }
        }
      }
      .myIcon{
        display: inline-block;
        padding-left: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/z-nav-menu.vue